import { jsx } from 'react/jsx-runtime';

const UserMenuGroup = ({ children }) => {
    return (jsx("li", { className: "mci-flex mci-flex-col mci-border-b-1 mci-border-b-gray-300 mci-py-xxs first:mci-pt-xs last:mci-border-b-0 last:mci-pb-xs", children: jsx("ul", { children: children }) }));
};

export { UserMenuGroup };
